import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../context/AuthContext';
import Breadcrumbs from '../components/Breadcrumbs';
import WebApplicationSchema from '../components/WebApplicationSchema';
import FAQPageSchema from '../components/FAQPageSchema';
import { Helmet } from 'react-helmet';

export const menHairstyles = 
[
  {
      id: '147641889812645907',
      name: 'Crewcut Purple',
      image: '/hairstyles/men-hairstyle/Crewcut Purple.jpg',
      gender: 'men',
      description: 'Vibrant purple crewcut for a bold style'
  },
  {
      id: '3887',
      name: 'Buzzcut',
      image: '/hairstyles/men-hairstyle/Buzzcut.jpg',
      gender: 'men',
      description: 'Classic buzzcut for a clean and dashing look  '
  },
  {
      id: '7571',
      name: 'Bowlcut',
      image: '/hairstyles/men-hairstyle/Bowlcut.jpg',
      gender: 'men',
      description: "Retro bowlcut for a youthful vibe"
  },
  {
      id: '155157438734009345',
      name: 'Long Wavy',
      image: '/hairstyles/men-hairstyle/Long Wavy.jpg',
      gender: 'men',
      description: "Flowing, long wavy hair for a relaxed, natural style"
  },
  {
      id: '147208380518237185',
      name: 'Long Wavy Blond',
      image: '/hairstyles/men-hairstyle/Long Wavy Blond.jpg',
      gender: 'men',
      description: "Blonde long wavy hair for a laid-back, beachy look"
  },
  {
      id: '5239',
      name: 'Crewcut',
      image: '/hairstyles/men-hairstyle/Crewcut.jpg',
      gender: 'men',
      description: "Short, stylish crewcut for a professional look"
  },
  {
      id: '7575',
      name: 'Curtain',
      image: '/hairstyles/men-hairstyle/Curtain.jpg',
      gender: 'men',
      description: "Curtain hairstyle with side-swept bangs for a trendy look"
  },
  {
      id: '7577',
      name: 'Short Curly',
      image: '/hairstyles/men-hairstyle/Short Curly.jpg',
      gender: 'men',
      description: "Short and curly hair for a voluminous and playful style"
  },
  {
      id: '147643262310549526',
      name: 'Short Curly Indigo',
      image: '/hairstyles/men-hairstyle/Short Curly Indigo.jpg',
      gender: 'men',
      description: "Short curly hair with a bold indigo color for a unique look"
  },
  {
      id: '107400721166501891',
      name: 'Bald',
      image: '/hairstyles/men-hairstyle/Bald.jpg',
      gender: 'men',
      description: "Clean-shaven head for a minimalist, sleek style"
  }
]


export const womenHairstyles = [
    {
        id: '6659',
        name: 'Messy Bun',
        image: '/hairstyles/women-hairstyle/Messy Bun.jpg',
        gender: 'female',
        description: "Casual, messy bun for an effortless look"
    },
    {
        id: '3885',
        name: 'Long Wavy',
        image: '/hairstyles/women-hairstyle/Long Wavy.jpg',
        gender: 'female',
        description: "Soft, long waves for a flowing, natural style"
    },
    {
        id: '6657',
        name: 'Long Straight',
        image: '/hairstyles/women-hairstyle/Long Straight.jpg',
        gender: 'female',
        description: "Sleek, straight long hair for a smooth and polished look"
    },
    {
        id: '6655',
        name: 'Pixie',
        image: '/hairstyles/women-hairstyle/Pixie.jpg',
        gender: 'female',
        description: "Chic pixie cut for a bold, fashionable style"
    },
    {
        id: '107396801031570693',
        name: 'Medium Straight',
        image: '/hairstyles/women-hairstyle/Medium Straight.jpg',
        gender: 'female',
        description: "Medium-length straight hair for a versatile, everyday look"
    },
    {
        id: '133036255729420334',
        name: 'Tight Curls',
        image: '/hairstyles/women-hairstyle/Tight Curls.jpg',
        gender: 'female',
        description: "Tight curls for a voluminous and textured hairstyle"
    },
    {
        id: '148299176935949341',
        name: 'Messy Bun Brown',
        image: '/hairstyles/women-hairstyle/Messy Bun Brown.jpg',
        gender: 'female',
        description: "Messy bun with brown hair for a casual yet stylish look"
    },
    {
        id: '142176244283213827',
        name: 'Long Wavy Blonde',
        image: '/hairstyles/women-hairstyle/Long Wavy Blonde.jpg',
        gender: 'female',
        description: "Blonde long wavy hair for a beachy, effortless style"
    },
    {
        id: '133029014779462706',
        name: 'Casual Updo',
        image: '/hairstyles/women-hairstyle/Casual Updo.jpg',
        gender: 'female',
        description: "Casual updo for an easy, sophisticated look"
    },
    {
        id: '10819',
        name: 'Beachy',
        image: '/hairstyles/women-hairstyle/Beachy.jpg',
        gender: 'female',
        description: "Beachy waves for a laid-back, sun-kissed style"
    },
    {
        id: '155244553626978384',
        name: 'Mid-Length Curls',
        image: '/hairstyles/women-hairstyle/Mid-Length Curls.jpg',
        gender: 'female',
        description: "Mid-length curls for a bouncy, voluminous look"
    },
    {
        id: '148023795112739897',
        name: 'Long Straight Black',
        image: '/hairstyles/women-hairstyle/Long Straight Black.jpg',
        gender: 'female',
        description: "Long straight black hair for a sleek and elegant style"
    },
    {
      id: '142177410215838726',
      name: 'Pixie Pink',
      image: '/hairstyles/women-hairstyle/Pixie Pink.jpg',
      gender: 'female',
      description: "A bold pink pixie cut for a vibrant, edgy look"
  },
  {
      id: '10857',
      name: 'Bobcut Wavy',
      image: '/hairstyles/women-hairstyle/Bobcut Wavy.jpg',
      gender: 'female',
      description: "Wavy bobcut for a stylish and chic appearance"
  },
  {
      id: '5213',
      name: 'Bobcut',
      image: '/hairstyles/women-hairstyle/Bobcut.jpg',
      gender: 'female',
      description: "Classic bobcut for a clean and polished look"
  },
  {
      id: '148023795045631032',
      name: 'Bobcut Green',
      image: '/hairstyles/women-hairstyle/Bobcut Green.jpg',
      gender: 'female',
      description: "A vibrant green bobcut for a unique and bold style"
  },
  {
      id: '5217',
      name: 'Curtain Wavy',
      image: '/hairstyles/women-hairstyle/Curtain Wavy.jpg',
      gender: 'female',
      description: "Wavy curtain hairstyle for a soft and romantic look"
  },
  {
      id: '150095442237982805',
      name: 'Bouncy Curls',
      image: '/hairstyles/women-hairstyle/Bouncy Curls.jpg',
      gender: 'female',
      description: "Bouncy curls for a fun, voluminous style"
  },
  {
      id: '5211',
      name: 'Afro',
      image: '/hairstyles/women-hairstyle/Afro.jpg',
      gender: 'female',
      description: "Bold afro for a natural and striking look"
  },
  {
      id: '5215',
      name: 'Romantic Waves',
      image: '/hairstyles/women-hairstyle/Romantic Waves.jpg',
      gender: 'female',
      description: "Soft, romantic waves for a dreamy and elegant appearance"
  },
  {
      id: '6663',
      name: 'Loose Waves',
      image: '/hairstyles/women-hairstyle/Loose Waves.jpg',
      gender: 'female',
      description: "Loose waves for a relaxed, carefree vibe"
  },
  {
      id: '142180678971164676',
      name: 'Loose Waves Reddish',
      image: '/hairstyles/women-hairstyle/Loose Waves Reddish.jpg',
      gender: 'female',
      description: "Loose reddish waves for a warm, rich hairstyle"
  },
  {
      id: '155537250061387827',
      name: 'Sleek Middle Part',
      image: '/hairstyles/women-hairstyle/Sleek Middle Part.jpg',
      gender: 'female',
      description: "Sleek middle part for a sophisticated and polished look"
  }
  ,{
    id: '6669',
    name: 'Short Bob',
    image: '/hairstyles/women-hairstyle/Short Bob.jpg',
    gender: 'female',
    description: "A short bob for a clean, modern look"
},
{
    id: '157312489262941356',
    name: 'Short Bob Inky Blue',
    image: '/hairstyles/women-hairstyle/Short Bob Inky Blue.jpg',
    gender: 'female',
    description: "A short bob with an inky blue shade for a striking appearance"
},
{
    id: '116819137308657732',
    name: 'Curly Bob',
    image: '/hairstyles/women-hairstyle/Curly Bob.jpg',
    gender: 'female',
    description: "A curly bob for a playful and voluminous style"
},
{
    id: '169979129947489417',
    name: 'Buzz Cut',
    image: '/hairstyles/women-hairstyle/Buzz Cut.jpg',
    gender: 'female',
    description: "A buzz cut for a bold and minimalistic style"
},
{
    id: '10817',
    name: 'Combover',
    image: '/hairstyles/women-hairstyle/Combover.jpg',
    gender: 'female',
    description: "A sleek combover hairstyle for a refined look"
},
{
    id: '116731147513235462',
    name: 'Gentle Waves',
    image: '/hairstyles/women-hairstyle/Gentle Waves.jpg',
    gender: 'female',
    description: "Soft, gentle waves for a smooth, elegant appearance"
},
{
    id: '6665',
    name: 'Bobcut Curly',
    image: '/hairstyles/women-hairstyle/Bobcut Curly.jpg',
    gender: 'female',
    description: "Curly bobcut for a fun, bouncy hairstyle"
},
{
    id: '150805552383920223',
    name: 'New York Beehive',
    image: '/hairstyles/women-hairstyle/New York Beehive.jpg',
    gender: 'female',
    description: "A dramatic beehive hairstyle, perfect for making a bold statement"
},
{
    id: '6673',
    name: 'Top Bun',
    image: '/hairstyles/women-hairstyle/Top Bun.jpg',
    gender: 'female',
    description: "A top bun hairstyle for a clean, practical look"
},
{
    id: '6675',
    name: 'Space Buns',
    image: '/hairstyles/women-hairstyle/Space Buns.jpg',
    gender: 'female',
    description: "Playful space buns for a fun, quirky style"
},
{
    id: '6661',
    name: 'Two Braids',
    image: '/hairstyles/women-hairstyle/Two Bairds.jpg',
    gender: 'female',
    description: "Two braids for a stylish and practical look"
}
];

export const extentionsHairstyles = [
    {
      id: '206227835667350899',
      name: 'Short',
      image: 'hairstyles/hairstyle_extension/206227835667350899_Length 1.jpg',
      gender: 'extension',
      description: "Short length for females"
    },
    {
      id: '206227835667350900',
      name: 'Medium',
      image: 'hairstyles/hairstyle_extension/206227835667350900_Length 2 .jpg',
      gender: 'extension',
      description: "Medium length for females"
    },
    {
      id: '206227835667350901',
      name: 'Long',
      image: 'hairstyles/hairstyle_extension/206227835667350901_Length 3.jpg',
      gender: 'extension',
      description: "Long length for females"
    }
]

export const bangsHairstylesWomen = [
  {
    id: '200000000000000814',
    name: 'Thin Bangs',
    image: 'hairstyles/bangs-103/200000000000000814_Thin Bangs.jpg',
    gender: 'bangs-103',
    description: 'A sleek and modern hairstyle for women'
  },
  {
    id: '200000000000000955',
    name : 'Left Side Swept',
    image: 'hairstyles/bangs-103/200000000000000955_Left Side Swept.jpg',
    gender: 'bangs-103',
    description: 'A trendy and feminine hairstyle for women'
  },
  {
    id: '200000000000000956',
    name : 'Right Side Swept',
    image: 'hairstyles/bangs-103/200000000000000956_Right Side Swept.jpg',
    gender: 'bangs-103',
    description: 'A trendy and feminine hairstyle for women'
  },
  {
    id : '200000000000001027',
    name : 'Sleek Bangs',
    image: 'hairstyles/bangs-103/200000000000001027_Sleek Bangs.jpg',
    gender: 'bangs-103',
    description: 'A sleek and modern hairstyle for women'
  },
  {
    id : '200000000000001028',
    name : 'Wispy Bangs',
    image: 'hairstyles/bangs-103/200000000000001028_Wispy Bangs.jpg',
    gender: 'bangs-103',
    description: 'A wispy and modern hairstyle for women'
  },
  {
    id : '200000000000001029',
    name : 'Centered Bangs',
    image: 'hairstyles/bangs-103/200000000000001029_Wispy Bangs 2.jpg',
    gender: 'bangs-103',
    description: 'A wispy and modern hairstyle for women'
  },
  {
    id : '206227835667350983',
    name : 'Split Mini Fringe',
    image: 'hairstyles/bangs-103/206227835667350983_Split Mini Fringe.jpg',
    gender: 'bangs-103',
    description: 'A short and modern hairstyle for women'
  },
  {
    id : '206227835667350984',
    name : 'Split Bangs',
    image: 'hairstyles/bangs-103/206227835667350984_Split Bangs.jpg',
    gender: 'bangs-103',
    description: 'A short and modern hairstyle for women'
  },
  {
    id : '206227835667350985',
    name : 'Mini Fringe',
    image: 'hairstyles/bangs-103/206227835667350985_Mini Fringe.jpg',
    gender: 'bangs-103',
    description: 'Mini fringe for a modern look'
  },
  {
    id: '219691778809268788',
    name : 'Blunt Bangs',
    image: 'hairstyles/bangs-103/219691778809268788_Blunt Bangs.jpg',
    gender: 'bangs-103',
    description: 'Blunt bangs for a modern look'
  }
]

export const bangsHairstylesMen = [
  {
    id: '219691778809269123',
    name : 'Blunt Bangs',
    image: 'hairstyles/bangs-104/219691778809269123_Blunt Bangs.jpg',
    gender: 'bangs-104',
    description: 'Modern blunt bangs for a modern look'
  },
  {
    id: '219691778809269125',
    name : 'Sleek Bangs',
    image: 'hairstyles/bangs-104/219691778809269125_Sleek Bangs.jpg',
    gender: 'bangs-104',
    description: 'Modern sleek bangs for a modern look'
  },
  {
    id: '219691778809269126',
    name : 'Mini Fringe',
    image: 'hairstyles/bangs-104/219691778809269126_Mini Fringe.jpg',
    gender: 'bangs-104',
    description: 'Modern mini fringe for a modern look'
  },
  {
    id: '219691778809269128',
    name : 'Split Mini Fringe',
    image: 'hairstyles/bangs-104/219691778809269128_Split Mini Fringe.jpg',
    gender: 'bangs-104',
    description: 'Modern split mini fringe for a modern look'
  },
  {
    id: '219691778809269129',
    name : 'Split Bangs',
    image: 'hairstyles/bangs-104/219691778809269129_Split Bangs.jpg',
    gender: 'bangs-104',
    description: 'Modern split bangs for a modern look'
  },
  {
    id: '219691778809269158',
    name : 'Wispy Bangs',
    image: 'hairstyles/bangs-104/219691778809269158_Wispy Bangs.jpg',
    gender: 'bangs-104',
    description: 'Modern wispy bangs for a modern look'
  },
  {
    id: '219691778809269159',
    name : 'Wispy Bangs 2',
    image: 'hairstyles/bangs-104/219691778809269159_Wispy Bangs 2.jpg',
    gender: 'bangs-104',
    description: 'Modern long wispy bangs for a modern look'
  },
  {
    id: '219691778809269161',
    name : 'Right Side Swept',
    image: 'hairstyles/bangs-104/219691778809269161_Right Side Swept.jpg',
    gender: 'bangs-104',
    description: 'Modern right side swept bangs for a modern look'
  },
  {
    id: '219691778809269162',
    name : 'Thin Bangs',
    image: 'hairstyles/bangs-104/219691778809269162_Thin Bangs.jpg',
    gender: 'bangs-104',
    description: 'Modern thin bangs for a modern look'
  },
  {
    id: '219691778809269232',
    name : 'Left Side Swept',
    image: 'hairstyles/bangs-104/219691778809269232_Left Side Swept.jpg',
    gender: 'bangs-104',
    description: 'Modern left side swept bangs for a modern look'
  }
]

export const volumeHairstylesWomen = [
  {
    id: '200000000000000975',
    name: 'Subtle',
    image: '/hairstyles/hairstyle-volume-117112796700739608/200000000000000975_Subtle.jpg',
    gender: 'volume',
    description: 'Modern subtle volume for a modern look'
  },
  {
    id: '200000000000000976',
    name: 'Natural',
    image: '/hairstyles/hairstyle-volume-117112796700739608/200000000000000976_Natural.jpg',
    gender: 'volume',
    description: 'Modern natural volume for a modern look'
  },
  {
    id: '200000000000000977',
    name: 'Medium',
    image: '/hairstyles/hairstyle-volume-117112796700739608/200000000000000977_Medium.jpg',
    gender: 'volume',
    description: 'Modern medium volume for a modern look'
  },
  {
    id: '200000000000000978',
    name: 'High',
    image: '/hairstyles/hairstyle-volume-117112796700739608/200000000000000978_High.jpg',
    gender: 'volume',
    description: 'Modern high volume for a modern look'
  },
  {
    id: '200000000000000979',
    name: 'Maximized',
    image: '/hairstyles/hairstyle-volume-117112796700739608/200000000000000979_Maximized.jpg',
    gender: 'volume',
    description: 'Modern maximized volume for a modern look'
  }
]

const HairstyleGallery = () => {
  const [selectedGender, setSelectedGender] = useState('all');
  const { user } = useAuth();
  const navigate = useNavigate();

  const formatStyleName = (styleName) => {
    return styleName
        .replace(/\b([A-Z])/g, (match) => match.toLowerCase()) // Convert first letter of each word to lowercase
        .replace(/\s+/g, "-"); // Replace spaces with hyphens
};

  const handleTryOn = (style) => {
    if (!user) {
      navigate('/login');
      return;
    }
    navigate('/try-on', { state: { hairstyleId: style.id } });
  };

  const filteredStyles = 
  selectedGender === 'all' ? [...menHairstyles, ...womenHairstyles, ...extentionsHairstyles, ...bangsHairstylesWomen, ...bangsHairstylesMen] :
  selectedGender === 'men' ? [...menHairstyles] :
  selectedGender === 'women' ? [...womenHairstyles] :
  selectedGender === 'extensions' ? [...extentionsHairstyles] :
  selectedGender === 'bangs-103' ? [...bangsHairstylesWomen] :
  selectedGender === 'bangs-104' ? [...bangsHairstylesMen] :
  selectedGender === 'volume' ? [...volumeHairstylesWomen] :
  [];

  const features = [
    {
      title: "AI-Powered Transformation",
      description: "Experience the magic of AI as it transforms your photos with stunning new hairstyles in seconds."
    },
    {
      title: "Extensive Style Collection",
      description: "Choose from hundreds of trendy hairstyles for both men and women, or upload your own reference."
    },
    {
      title: "Realistic Results",
      description: "Our advanced AI ensures natural-looking results that match your facial features perfectly."
    }
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "AI Hairstyle Studio Salon",
    "description": "Discover your perfect look with AI Hairstyle Studio's Hairstyle Gallery! Browse and try on different hairstyles, haircuts, and colors instantly with AI-powered virtual styling.",
    "applicationCategory": "Beauty & Lifestyle",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "featureList": features.map(f => f.title).join(", ")
  };



  return (<>
    <Helmet>
        <WebApplicationSchema />
        <Breadcrumbs />
        <FAQPageSchema />
        <title>AI Hairstyle Studio - Hairstyle Gallery</title>
        <meta name="description" content="Discover your perfect look with AI Hairstyle Studio's Hairstyle Gallery! Browse and try on different hairstyles, haircuts, and colors instantly with AI-powered virtual styling." />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
    <div className="min-h-screen bg-white">
      <div className="container py-8">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-black mb-4 animate-fade-in">
            Studio Hair Salon Gallery
          </h1>
          <p className="text-gray text-lg mb-8 animate-slide-up">
            Choose from Studio A Hair Salon Gallery and transform your look instantly with our <a className="text-teal-300" href="https://www.aihairstylestudio.com/">AI Hairstyles Generator</a>. 
            This simple app lets you get a new style that suits your features in seconds. Whether you’re aiming for a bold change or a subtle tweak, 
            this professional AI hairstyle Changer for men and women helps you find the beauty you’ve been dreaming of. 
            No appointment is required. Just pick a style below, and watch the magic happen. Try it today and shine with a look that’s truly yours!
          </p>

          {/* Filter Buttons */}
          <div className="flex flex-wrap justify-center gap-2 sm:gap-4 mb-8">
            <button
              onClick={() => setSelectedGender('all')}
              className={`btn ${selectedGender === 'all' ? 'btn-primary' : 'btn-secondary'} text-sm sm:text-base`}
            >
              All Styles
            </button>
            <button
              onClick={() => setSelectedGender('men')}
              className={`btn ${selectedGender === 'men' ? 'btn-primary' : 'btn-secondary'} text-sm sm:text-base`}
            >
              Men's Styles
            </button>
            <button
              onClick={() => setSelectedGender('women')}
              className={`btn ${selectedGender === 'women' ? 'btn-primary' : 'btn-secondary'} text-sm sm:text-base`}
            >
              Women's Styles
            </button>
            <button
              onClick={() => setSelectedGender('extensions')}
              className={`btn ${selectedGender === 'extensions' ? 'btn-primary' : 'btn-secondary'} text-sm sm:text-base`}
            >
              Women's Hair Extensions
            </button>
            <button
              onClick={() => setSelectedGender('bangs-103')}
              className={`btn ${selectedGender === 'bangs-103' ? 'btn-primary' : 'btn-secondary'} text-sm sm:text-base`}
            >
              Bangs Women
            </button>
            <button
              onClick={() => setSelectedGender('bangs-104')}
              className={`btn ${selectedGender === 'bangs-104' ? 'btn-primary' : 'btn-secondary'} text-sm sm:text-base`}
            >
              Bangs Men
            </button>
            <button
              onClick={() => setSelectedGender('volume')}
              className={`btn ${selectedGender === 'volume' ? 'btn-primary' : 'btn-secondary'} text-sm sm:text-base`}
            >
              Hair Volume
            </button>
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredStyles.map((style) => (
            <motion.div
              key={style.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="card hover-scale"
            >
              <div className="relative aspect-w-4 aspect-h-3 mb-4">
                <img
                  src={style.image}
                  alt={style.name}
                  className="w-full h-full object-cover rounded-xl"
                />
              </div>
              <h3 className="text-xl font-semibold text-black mb-2">{style.name}</h3>
              <p className="text-gray mb-4">{style.description}</p>
              <div className="flex gap-3">
                <button
                  onClick={() => handleTryOn(style)}
                  className="btn btn-primary flex-1"
                >
                  Try Now
                </button>
                <Link
                  to={`/studio-hair-salon/${encodeURIComponent(style.name)}`}
                  state={{ id: style.id }}
                  className="btn btn-secondary flex-1"
                >
                  Learn More
                </Link>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA Section */}
        {!user && (
          <div className="text-center mt-16 p-8 card gradient-teal text-white">
            <h2 className="text-2xl font-bold mb-4">
              Ready to try these styles on yourself?
            </h2>
            <p className="mb-6">
              Sign up now to use our AI-powered virtual try-on feature!
            </p>
            <Link to="/signup" className="btn btn-primary hover-scale">
              Get Started 
            </Link>
          </div>
        )}
      </div>
    </div>
  </>
  );
};

export default HairstyleGallery;
